import React, { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker';
import { MdOutlineClose } from "react-icons/md";
import { FaFilter, FaHome } from 'react-icons/fa';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { getSessionFilter, setSessionFilter } from '../../utils/sessionStorage';

const ScreeningFilter = ({ queryParams }) => {

    const navigate = useNavigate();

    const [showFilterDropdown, setShowFilterDropdown] = useState(false);
    
    // Initialize filter data from sessionStorage or use defaults
    const [filterData, setFilterData] = useState(() => {
        const savedFilter = getSessionFilter('screeningFilter') || {
            from_date: moment().subtract(1, 'years').format('YYYY-MM-DD'),
            to_date: moment().format('YYYY-MM-DD'),
            search_term: '',
            page_limit: 4000,
            skip_count: 0,
            role_type: ''
        };
        return savedFilter;
    });

    const updateValue = (key, value) => {
        setFilterData((prevState) => {
            const newState = { ...prevState, [key]: value };
            // Save to sessionStorage whenever filter changes
            setSessionFilter('screeningFilter', newState);
            return newState;
        });
    };

    const applyFilters = () => {
        setShowFilterDropdown((prevState) => !prevState);
        // Update URL without query params
        navigate('/screening-count');
    }

    const resetFilters = () => {
        const defaults = {
            from_date: moment().subtract(1, 'years').format('YYYY-MM-DD'),
            to_date: moment().format('YYYY-MM-DD'),
            search_term: '',
            page_limit: 4000,
            skip_count: 0,
            role_type: ''
        };
        setFilterData(defaults);
        setSessionFilter('screeningFilter', defaults);
        setShowFilterDropdown((prevState) => !prevState);
        navigate('/screening-count');
    }

    // Load initial data from sessionStorage on mount
    useEffect(() => {
        const savedFilter = getSessionFilter('screeningFilter');
        if (savedFilter) {
            setFilterData(savedFilter);
        }
    }, [])

    const margin = 100;
    const records = Array.from({ length: 21 }, (_, i) => i * margin);

    return (
        <div className="filters-container">
            <button
                onClick={() => {
                    // Navigate without query params, will use sessionStorage
                    navigate('/users')
                }}
                className="filter-button"
            >
                <FaHome /> Home
            </button>
            <span style={{ fontSize: '35px' }}>Screening Count</span>
            <div className="filter-container">
                <button onClick={() => setShowFilterDropdown((prevState) => !prevState)} className="filter-button"><FaFilter /> Filter</button>
                {showFilterDropdown && (
                    <div className="filter-dropdown filters">
                        <div onClick={() => setShowFilterDropdown((prevState) => !prevState)} className='close-btn'>
                            <MdOutlineClose />
                        </div>
                        <div className="filter-option">
                            <label>From Date:</label>
                            <DatePicker
                                selected={filterData?.from_date ? moment(filterData.from_date, 'YYYY-MM-DD').toDate() : null}
                                onChange={(date) => updateValue('from_date', moment(date).format('YYYY-MM-DD'))}
                                placeholderText="Select From Date"
                                dateFormat="dd/MM/yyyy"
                            />
                        </div>
                        <div className="filter-option">
                            <label>To Date:</label>
                            <DatePicker
                                selected={filterData?.to_date ? moment(filterData?.to_date, 'YYYY-MM-DD').toDate() : null}
                                onChange={(date) => updateValue('to_date', moment(date).format('YYYY-MM-DD'))}
                                placeholderText="Select To Date"
                                dateFormat="dd/MM/yyyy"
                            />
                        </div>
                        <div className="filter-option">
                            <label>No of Records:</label>
                            <select
                                value={filterData?.page_limit || ""}
                                onChange={(e) => updateValue('page_limit', e.target.value || '')}
                            >
                                {records?.map((item, idx) => {
                                    if (item === 0) {
                                        return null;
                                    }
                                    return (
                                        <option key={idx} value={item}>{item}</option>
                                    );
                                })}
                            </select>
                        </div>
                        <div className="filter-option">
                            <label>Search:</label>
                            <input
                                type="text"
                                value={filterData?.search_term}
                                onChange={(e) => updateValue('search_term', e.target.value)}
                                placeholder="Search by name or Aadhar"
                            />
                        </div>
                        <div className="filter-actions">
                            <button onClick={applyFilters}>Apply Filters</button>
                            <button onClick={resetFilters}>
                                Reset Filters
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default ScreeningFilter